import { types } from './actions';

const initialState = {
  isDeletingWorkStep: false,
  isFetchingQuoteWorkflow: false,
  isFetchingWorkSteps: false,
  quoteWorkflow: null,
  workSteps: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ADD_WORK_STEP:
      return {
        ...state,
        workSteps: [...state.workSteps, payload.workStep],
      };
    case types.EDIT_WORK_STEP: {
      return {
        ...state,
        workSteps: [
          ...state.workSteps.filter((step) => step.id !== payload.workStep.id),
          payload.workStep,
        ],
      };
    }
    case types.DELETE_WORK_STEP_ERROR:
      return {
        ...state,
        isDeletingWorkStep: false,
      };
    case types.DELETE_WORK_STEP_REQUEST:
      return {
        ...state,
        isDeletingWorkStep: true,
      };
    case types.DELETE_WORK_STEP_SUCCESS:
      return {
        ...state,
        isDeletingWorkStep: false,
        workSteps: state.workSteps.filter(
          (step) => step.id !== payload.workStepId,
        ),
      };
    case types.FETCH_QUOTE_WORKFLOW_ERROR:
      return {
        ...state,
        isFetchingQuoteWorkflow: false,
      };
    case types.FETCH_QUOTE_WORKFLOW_REQUEST:
      return {
        ...state,
        isFetchingQuoteWorkflow: true,
      };
    case types.FETCH_QUOTE_WORKFLOW_SUCCESS:
      return {
        ...state,
        isFetchingQuoteWorkflow: false,
        quoteWorkflow: payload.quoteWorkflow,
      };
    case types.FETCH_WORK_STEPS_ERROR:
      return {
        ...state,
        isFetchingWorkSteps: false,
      };
    case types.FETCH_WORK_STEPS_REQUEST:
      return {
        ...state,
        isFetchingWorkSteps: true,
      };
    case types.FETCH_WORK_STEPS_SUCCESS:
      return {
        ...state,
        isFetchingWorkSteps: false,
        workSteps: payload.workSteps,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.workflows.workflowsLists;

export const getWorkSteps = (state) => getScope(state).workSteps;

export const getQuoteWorkflow = (state) => getScope(state).quoteWorkflow;

export const getIsDeletingWorkStep = (state) =>
  getScope(state).isDeletingWorkStep;

export const getIsFetchingWorkSteps = (state) =>
  getScope(state).isFetchingWorkSteps;

export const getIsFetchingQuoteWorkflow = (state) =>
  getScope(state).isFetchingQuoteWorkflow;
